import "normalize.css/normalize.css";
import { apiGetDirectCheckoutLink } from "../../../../utils/api";

import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";
import { hideTooltip, setTooltip } from "../../../../utils/clipboard";
import { defer } from "../../../../utils/script";

export default class CreateLink extends DComponent {
  constructor({
    parent,
    id,
    orderCode,
    hide,
    disabled = false,
    attention,
    isModal = false,
  } = {}) {
    super(arguments[0], isModal ? ".main-page" : parent, id, {
      class: classNames("CreateLink", {
        "is-modal": isModal
      }),
    }, true);
    this.orderCode = orderCode;
    this.hide = hide
    this.disabled = disabled;
    this.attention = attention;
    this.isModal = isModal;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "CreateLink");
  }

  loadHtml() {
    return this.isModal ? require("html-loader!./modal.html") : require("html-loader!./index.html");
  }

  after() {
    this.onEvent();
    this.setupCopy();
  }

  onEvent() {
    $(".create-button", this.element).on("click", () => {
      $(".create-button", this.element).addClass("loading");
      let params = {
        "code": this.orderCode
      }
      apiGetDirectCheckoutLink(params,
        (data) => {
          if (data) {
            this.fillDirectLink(data);
            this.element.addClass("created");
          }
          $(".create-button", this.element).removeClass("loading")
        },
        () => {
          $(".create-button", this.element).removeClass("loading")
        }
      )
    })

    if (this.isModal) {
      this.element.on('hidden.bs.modal', () => {
        $("html, body").css("overflow", "auto");
      })
    }
  }

  fillDirectLink(data) {
    if (data && data.data && data.data.url) {
      $('.copy-button', this.element).attr("data-clipboard-text", data.data.url);
      $('.copy-button .value', this.element).text(data.data.url);
    }
  }

  updateCreateLink(_params) {
    defer(() => this.element, () => {
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
      });
      this.setUpComponent();
    });
  }

  setUpComponent() {
    $(".create-button", this.element).attr("disabled", !!this.disabled);
    if (this.attention) {
      $(".attention .attention-value", this.element).text($.i18n(this.attention));
      $(".attention .attention-value", this.element).attr("data-i18n", this.attention);
    }
    this.resetCreateLink();
  }

  setupCopy() {
    // eslint-disable-next-line no-undef
    const clipboard = new Clipboard('.CreateLink .copy-button');

    clipboard.on('success', function (e) {
      setTooltip(e.trigger, 'Copied!');
      hideTooltip(e.trigger);
    });

    clipboard.on('error', function (e) {
      setTooltip(e.trigger, 'Failed!');
      hideTooltip(e.trigger);
    });
  }

  resetCreateLink() {
    this.element.removeClass("created");
  }

  showCreateLink() {
    this.element.removeClass("hide");
  }

  hideCreateLink() {
    this.element.addClass("hide");
  }

  animation() {
    $(this.element).addClass("animation");
    setTimeout(() => {
      $(this.element).removeClass("animation");
    }, 1000);
  }

  showModalCreateLink() {
    $("html, body").css("overflow", "hidden");
    this.element.modal("show");
  }

  hideModalCreateLink() {
    this.element.modal("hide");
  }
}